import fetch from '@/api/fetch';

const path = process.env.VUE_APP_SYSTEM_SERVER_URL;

export const fetchCollectList = req =>
  fetch({
    url: path + '/adminChange/queryCollect',
    timeout: 30000,
    ...req,
  });
export const addCollect = req =>
  fetch({
    url: path + '/adminChange/saveCollect',
    method: 'post',
    ...req,
  });
export const delCollect = req =>
  fetch({
    url: path + '/adminChange/delteCollect',
    ...req,
  });
